var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"401-container"},[_c('errorPage',{attrs:{"title":_vm.$t('errorPages.title404'),"headline":_vm.$t('errorPages.headline404'),"message":_vm.$t('errorPages.message404')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }